import { useState, useCallback } from 'react';

/* Preferencia de vista (mosaico/tabla) recordada por módulo. Mismo helper para
   Catálogo y POS — que la app recuerde cómo te gusta ver las cosas es básico, y
   tener uno que recuerda y otro que no sería inconsistencia. Sin storage
   (modo privado/bloqueado) degrada a solo-sesión sin romper. */
export default function useViewMode(storageKey, initial = 'grid') {
  const [mode, setMode] = useState(() => {
    try { return localStorage.getItem(storageKey) || initial; } catch { return initial; }
  });
  const set = useCallback((next) => {
    setMode(next);
    try { localStorage.setItem(storageKey, next); } catch { /* sin storage: solo esta sesión */ }
  }, [storageKey]);
  return [mode, set];
}
